import '../css/index.scss';
import APlayer from './player';
export default APlayer;